(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vaslora-custom-styles"] && !Shopify.designMode) return;
  try {
    (function(){
  var THRESHOLD = 6000; // $60 in cents
  function fmt(cents){ return '$' + (cents/100).toFixed(2); }
  function render(container, totalCents){
    if(!container) return;
    var existing = container.querySelector('.vaslora-shipbar');
    if(existing) existing.remove();
    var remaining = Math.max(0, THRESHOLD - totalCents);
    var pct = Math.min(100, Math.round((totalCents / THRESHOLD) * 100));
    var msg;
    if(remaining <= 0){
      msg = '<strong>Nice — you unlocked FREE US shipping.</strong>';
    } else {
      msg = 'You\'re <strong>' + fmt(remaining) + '</strong> away from <strong>FREE US shipping</strong>.';
    }
    var el = document.createElement('div');
    el.className = 'vaslora-shipbar' + (remaining<=0 ? ' is-complete' : '');
    el.innerHTML = '<div class="vaslora-shipbar__row">'+
      '<svg class="vaslora-shipbar__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>'+
      '<span>'+msg+'</span></div>'+
      '<div class="vaslora-shipbar__track"><div class="vaslora-shipbar__fill" style="width:'+pct+'%"></div></div>';
    container.prepend(el);
  }
  function refresh(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        if(!cart) return;
        var total = cart.total_price;
        // Cart page main container
        var mounts = [];
        // Do not mistake a product's /cart/add form for the cart page.
        var cartPage = /\/cart\/?$/.test(location.pathname)
          ? document.querySelector('main .cart-items, main [data-cart-items], main form[action^="/cart"], main .cart, .cart__contents')
          : null;
        if(cartPage) mounts.push(cartPage);
        // Cart drawer
        var drawer = document.querySelector('cart-drawer-component, .cart-drawer, [data-cart-drawer]');
        if(drawer) mounts.push(drawer);
        mounts.forEach(function(m){ render(m, total); });
      })
      .catch(function(){});
  }
  function init(){
    if(location.pathname === '/cart' || document.querySelector('cart-drawer-component,.cart-drawer,[data-cart-drawer]')){
      refresh();
    }
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  // Refresh whenever cart updates
  ['cart:refresh','cart:update','cart:item-added','cart:change'].forEach(function(evt){
    document.addEventListener(evt, refresh);
    window.addEventListener(evt, refresh);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
